import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import { Experiment } from "../../../../constants/experiments"
import { useIsExperiment } from "../../../../hooks/experiments"

import ScrollLinksBanner from "@components/V2/Banners/ScrollLinksBanner/ScrollLinksBanner"

const StoryblokScrollLinksBanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.ScrollLinksBanner>) => {
  const isScrollLinksBannerEnabled = useIsExperiment(Experiment.SCROLL_LINKS)

  if (!isScrollLinksBannerEnabled) {
    return blok.navigationItems.map((item) => {
      return item.content.map((content) => {
        return <StoryblokComponent key={content._uid} blok={content} />
      })
    })
  }

  return (
    <ScrollLinksBanner
      backgroundColor={blok.backgroundColor}
      navigationItems={blok.navigationItems}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokScrollLinksBanner
